export const THUMB_SIZE_PAGE = { sm: "80px", xs: "50px" } as const;
export const THUMB_SIZE_MODAL = { sm: "72px", xs: "44px" } as const;

export const MAIN_IMAGE_HEIGHT_PAGE = {
  xs: "400px",
  sm: "550px",
  md: "450px",
} as const;

export const MAIN_IMAGE_HEIGHT_MODAL = {
  xs: "min(72vh, 520px)",
  sm: "min(78vh, 620px)",
  md: "min(75vh, 640px)",
} as const;

export const MODAL_BACKDROP_SX = {
  backgroundColor: "rgba(0, 0, 0, 0.72)",
  backdropFilter: "blur(2px)",
} as const;
